import { useEffect } from "react";

import useCurrentUser from "../../../hooks/useCurrentUser";
import { useGetUserFcmTokensRef } from "../FCM";
import { applyCreateTimestamp } from "../../../utils/timestamp";

export const useGetToken = () => {
  const { user } = useCurrentUser();
  const userTokensDoc = useGetUserFcmTokensRef();

  useEffect(() => {
    if (user.webviewFcmToken && userTokensDoc) {
      userTokensDoc
        .set(
          applyCreateTimestamp({
            fcmToken: user.webviewFcmToken,
          })
        )
        .catch((ex: any) => {
          console.log(ex.message);
        });
    }
  }, [user.webviewFcmToken, userTokensDoc]);
};
